import { createSlice } from "@reduxjs/toolkit";
import {  logoutThunk } from "./thunk";


export const initialState = {
  logoutData: [],
  logoutError: '', // for error message
  logoutLoading: false,
  
  
};

const Logout_user = createSlice({
  name: "Logout_user",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(logoutThunk.pending, (state) => {
      state.logoutLoading = true ;
      state.logoutData = [];
      state.logoutError = "";
  });
    builder.addCase(logoutThunk.fulfilled, (state, action) => {
        state.logoutData = action.payload.data;
        state.logoutLoading = false ;
    });
    builder.addCase(logoutThunk.rejected, (state, action) => {
      state.logoutError = action.logoutError?.message || action.payload?.message || "An unknown error occurred";
        state.logoutLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Logout_user.actions

export default Logout_user.reducer;